<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="18" :md="14">
        <div class="news">
            <h1>“一滴血评估女性卵巢功能”参展第十五届郑州美博会</h1>
            <p>  2020中国郑州国际高端美容院线产品及化妆品展览会举办（简称郑州美博会），本届展会汇聚1000多家国内参展商，观众预计达到160000人次。数量众多的来自各地的观众一早就来到会场门口，等待着这次美业盛典的正式开始。为呈现一个集贸易合作、获取新趋势、新事物的展会，美博会主办方下沉市场，通过线上社群、电话采访、美博国际线上商城、杂志到店等形式顺势扩大了领域内线上线下渠道采购商。同时集结多方的力量，多维开拓、创新数字化营销，赋能展商和观众。</p>
            <img src="@/assets/images/information/0807_4.jpg" alt="">
            <p>  展会期间名品荟萃，云集，是业内人士实现一站式采购计划的理想平台。此外，展会期间举行一系列兼具学术性及商业性的精彩活动及论坛，使郑州美博会的内涵更为丰富。本届展会上参展商众多，参展品类丰富，令到场参观的观众目不暇接。</p>
            <img src="@/assets/images/information/0807_1.jpg" alt="">
            <p>  趋势火热的大健康大医美版块也是引来了大批观展者前往洽谈，一系列配套专业美容的智能系统帮助美业提升服务水平，各种类目的新款仪器，让健康与美变得触手可及，备受买家青睐！苏州飞康展位内人气火爆，专业的出展让现场咨询签约数据不断攀升，不少意向客户纷纷前来体验,并对“一滴血评估女性卵巢功能”产品表示认可。</p>
            <img src="@/assets/images/information/0807_3.jpg" alt="">
            <br/><br/><br/>
            <img src="@/assets/images/information/0807_2.jpg" alt="">
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Cooperation",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.news {
  margin-top: 90px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  img{
    width:380px;
    height: auto;
    
  }
  .imgtxt {
    text-align: center;
    margin-top: 5px;
  }
  p {
    line-height: 28px;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  h1,
  h2 {
    margin-top: 20px;
  }
}
</style>
